import { render, staticRenderFns } from "./page-3.vue?vue&type=template&id=514589f6&scoped=true&"
import script from "./page-3.vue?vue&type=script&lang=js&"
export * from "./page-3.vue?vue&type=script&lang=js&"
import style0 from "./page-3.vue?vue&type=style&index=0&id=514589f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514589f6",
  null
  
)

export default component.exports